import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';

let config = {
  apiKey: "AIzaSyDqvbLA1BjIwcBoImfWxn3gYdh8NP3FJE4",
  authDomain: "estimato-40e81.firebaseapp.com",
  projectId: "estimato-40e81",
  storageBucket: "estimato-40e81.appspot.com",
  messagingSenderId: "725562908300"
};

firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js